// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3hs6-","inputWrap":"styles_inputWrap__1ydZJ","input":"styles_input__ProPP"};